import { render, staticRenderFns } from "./ConsultBanner.vue?vue&type=template&id=0dceb134&"
import script from "./ConsultBanner.vue?vue&type=script&lang=js&"
export * from "./ConsultBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConsultBanner.vue?vue&type=style&index=0&id=0dceb134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports